<template>
  <el-dialog title="退换货申请单信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="390" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="退换货申请单:" field="exchangeNo">
                    <template v-slot>
                      <el-input v-model="formData.exchangeNo" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="用户号码:" field="userMobile">
                    <template v-slot>
                      <el-input v-model="formData.userMobile" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
                    float: right;
                    margin-top: -39px;">
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'siteId'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.formData.siteId = this.siteId
    this.requestParam.siteId = this.siteId
  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      columns: [
        { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
        {
          title: '退换单号', field: 'exchangeNo', width: 180
        },
        { title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral" >
                    <span>审核中</span>
                  </div>
                ];
              }else if (row.stat == 5) {
                return [
                  <div class="txt-status ">
                    <span>已审核</span>
                  </div>
                ];
              }else if (row.stat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              }else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        // {
        //   title: '流程状态', field: 'flowStat', width: 80,
        // },
        {
          title: '退换来源', field: 'sourceType', width: 80, slots: {
            default: ({ row }) => {
              if (row.sourceType == 1) {
                return [
                  <div>
                    <span>安装工单</span>
                  </div>
                ];
              } else if (row.sourceType == 2) {
                return [
                  <div>
                    <span>维修工单</span>
                  </div>
                ];
              } else if (row.sourceType == 3) {
                return [
                  <div>
                    <span>委托维修</span>
                  </div>
                ];
              } else if (row.sourceType == 4) {
                return [
                  <div>
                    <span>事故报告</span>
                  </div>
                ];
              }else if (row.sourceType == 5) {
                return [
                  <div>
                    <span>质量报告</span>
                  </div>
                ];
              }else if (row.sourceType == 9) {
                return [
                  <div>
                    <span>其他</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: '来源单据', field: 'sourceNo', width: 80,
        },
        {
          title: '是否直发机', field: 'stat', width: 100, slots: {
            default: ({ row }) => {
              if (row.isDirectExchange == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isDirectExchange == 1) {
                return [
                  <div class="txt-status ">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '退换分类', field: 'exchangeTypeName', width: 100, },
        { title: '服务机构', field: 'orgName', width: 100, },
        { title: '服务商', field: 'siteName', width: 100, },
        { title: '用户姓名', field: 'userName', width: 100, },


        {
          title: '地址(省 市 区)', field: 'area', width: 235, slots: {
            default: ({ row }) => {
              return [<span>{row.userProvice}{row.userCity}{row.userTown}</span>]
            }
          }
        },
        { title: '产品大类', field: 'bigCategoryName', width: 80, },
        { title: '产品条码', field: 'barcode', width: 150, },

        { title: '产品名称', field: 'itemName', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ],


      total: 0,
      searchOrderNo: null,
      data: [],
      showBigSiteName: null,

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        siteId: null,
        exchangeNo:null,
        userMobile: null,
        stat:5,
        isGetByExchangeOrder:1,
      },
      requestParam: {
        siteId: null,
        exchangeNo:null,
        userMobile:null,
        stat:5,
        isGetByExchangeOrder:1,
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        orderId: null, orderNo: null
      }
    };
  },




  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent(e) {
      console.log(e.row.id, '单元格点击事件')
    },


    radioChangeEvent({row}) {
      this.selectedRow = {billId: row.id, billNo: row.exchangeNo, orgId: row.orgId, orgName: row.orgName,
        orgIdPath: row.orgIdPath,siteId: row.siteId, siteName:row.siteName, siteMan:row.siteMan,
        siteManMobile:row.siteManMobile, isDirectExchange:row.isDirectExchange,exchangeReason:row.exchangeReason,
        exchangeReasonName:row.exchangeReasonName,exchangeType:row.exchangeType,exchangeTypeName:row.exchangeTypeName,
        problemRemark:row.problemRemark,isUserQuestion:row.isUserQuestion,outWarehouseId:row.outWarehouseId,inWarehouseId:row.inWarehouseId,
        userName:row.userName, userMobile:row.userMobile, areaId:row.areaId,
        userProvince: row.userProvince,userCity: row.userCity, userCounty:row.userCounty, userTown:row.userTown,
        userAddress:row.userAddress,
        itemId:row.itemId,itemName:row.itemName, itemCode:row.itemCode,itemModel:row.itemModel, barcode:row.barcode,
        bigCategoryId:row.bigCategoryId, bigCategoryName:row.bigCategoryName, smallCategoryId:row.smallCategoryId,
        smallCategoryName:row.smallCategoryName, buyDate:row.buyDate,buyAmount:row.buyAmount,gasType:row.gasType,
        gasTypeName:row.gasTypeName,defaultReturnAreaId:row.defaultReturnAreaId,defaultReturnAddress:row.defaultReturnAddress,
        receiveMan:row.receiveMan,receiveMobile:row.receiveMobile,receiveProvince:row.receiveProvince,receiveCity:row.receiveCity,
        receiveCounty:row.receiveCounty,receiveTown:row.receiveTown,receiveAreaId:row.receiveAreaId,receiveAddress:row.receiveAddress,
        sysmtomPic:row.sysmtomPic,installPic:row.installPic,labelPic:row.labelPic,barcodePic:row.barcodePic,vedioUrl:row.vedioUrl
      }
    },



    commitRow() {
      this.$mask.open()

      if (this.selectedRow.orderNo !== null) {
        this.$emit('commit', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中数据')
      }
      this.$mask.close()

    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      console.log("我这里")



      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.wkExchangeBill.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);

      this.flushed()

    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}


::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -38px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
}
</style>
